import { render, staticRenderFns } from "./LocalizationChanger.vue?vue&type=template&id=0dd7a244&"
import script from "./LocalizationChanger.vue?vue&type=script&lang=js&"
export * from "./LocalizationChanger.vue?vue&type=script&lang=js&"
import style0 from "./LocalizationChanger.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports